import { Controller } from "@hotwired/stimulus"

// Drag handle on the expanded rail's right edge (shared/_phone_shell). Sets
// --rail-expanded-width on the .assistant-shell, which _docs.scss reads for
// the expanded rail's width, and remembers it per browser. Double-click puts
// the default back; arrow keys nudge it when the handle has focus.
const STORAGE_KEY = "nav_rail_width"
const MIN = 192
const MAX = 448
const STEP = 16

export default class extends Controller {
    connect() {
        this._shell = this.element.closest(".assistant-shell")
        this._onMove = this._onMove.bind(this)
        this._onUp = this._onUp.bind(this)
        const stored = this._stored()
        if (stored) this._set(stored)
    }

    disconnect() {
        this._onUp()
    }

    start(event) {
        if (event.button !== 0) return
        event.preventDefault()
        this._left = this._rail()?.getBoundingClientRect().left ?? 0
        this._shell?.classList.add("is-rail-resizing")
        document.addEventListener("pointermove", this._onMove)
        document.addEventListener("pointerup", this._onUp)
    }

    reset() {
        this._shell?.style.removeProperty("--rail-expanded-width")
        try {
            window.localStorage.removeItem(STORAGE_KEY)
        } catch {
            // nothing stored
        }
    }

    key(event) {
        const delta = { ArrowLeft: -STEP, ArrowRight: STEP }[event.key]
        if (!delta) return
        event.preventDefault()
        const current = this._rail()?.getBoundingClientRect().width ?? MIN
        this._save(this._set(current + delta))
    }

    _onMove(event) {
        this._width = this._set(event.clientX - this._left)
    }

    _onUp() {
        document.removeEventListener("pointermove", this._onMove)
        document.removeEventListener("pointerup", this._onUp)
        if (!this._shell?.classList.contains("is-rail-resizing")) return
        this._shell.classList.remove("is-rail-resizing")
        if (this._width) this._save(this._width)
    }

    _set(px) {
        const width = Math.round(Math.min(MAX, Math.max(MIN, px)))
        this._shell?.style.setProperty("--rail-expanded-width", `${width}px`)
        this.element.setAttribute("aria-valuenow", String(width))
        return width
    }

    _save(width) {
        try {
            window.localStorage.setItem(STORAGE_KEY, String(width))
        } catch {
            // the width still applies to this page
        }
    }

    _stored() {
        try {
            const value = Number(window.localStorage.getItem(STORAGE_KEY))
            return Number.isFinite(value) && value > 0 ? value : null
        } catch {
            return null
        }
    }

    _rail() {
        return this._shell?.querySelector(".assistant-bottom-nav")
    }
}
